import { CapoPlugin } from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];